import React from "react";
import { FiShield, FiZap, FiGlobe, FiCpu, FiCode, FiLayers, FiLayout, FiSearch, FiSmartphone } from "react-icons/fi";
import { FaReact, FaMobile, FaUniversalAccess, FaPlug } from "react-icons/fa";
import { SiRedux, SiReactrouter, SiMaterialdesign, SiStyledcomponents, SiAxios } from "react-icons/si";
import {
  LuPercent,
  LuShield,
  LuSettings,
  LuUsers,
  LuSmartphone,
  LuCircleCheck,
  LuLayers,
  LuShieldCheck,
  LuBuilding2,
  LuClipboardList,
  LuPalette,
  LuCode,
  LuBug,
  LuRocket,
} from "react-icons/lu";

export const ReactAppHeroData = {
  backgroundImage: "/images/serviceBanners/ReactBanner.webp",
  whiteImage: "/images/serviceBanners/ReactW.webp",
  subTitle: "ReactJS Development Services",
  title: (
    <>
      High Performance <br /> Component-Driven <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600">ReactJS</span> Apps
    </>
  ),
  description:
    "We build high performance ReactJS applications with component driven architecture, reusable UI components, efficient state management, and scalable solutions to deliver fast, responsive, and modern web experiences.",
  primaryButton: {
    title: "Get a Free Quote",
    onClick: () => console.log("React Quote clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("React Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "Virtual DOM Speed",
      desc: "Fast rendering using Virtual DOM for smooth and efficient UI performance.",
      iconColor: "#61dafb",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Modular Code",
      desc: "Reusable components that reduce development time and improve scalability.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Predictable State",
      desc: "State management using Redux and Context API for stable applications.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "SPA Routing",
      desc: "Seamless single-page navigation for faster and modern web experiences.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/reactjs.svg",
      top: "8%",
      right: "16%",
      containerSize: 70,
      iconSize: 50,
      glowColor: "rgba(97,218,251,0.35)",
      iconGlow: "rgba(97,218,251,0.9)",
    },
  ],
};

// 2. Performance Stats Block
export const reactStatsData = [
  {
    icon: LuSettings,
    value: "150+",
    label: "Apps Built",
    colorClass: "text-[#00d2ff]",
    bgClass: "bg-[#00d2ff]/10",
    borderClass: "border-[#00d2ff]/20",
    glowClass: "shadow-[0_0_20px_rgba(0,210,255,0.15)]",
  },
  {
    icon: LuUsers,
    value: "90+",
    label: "Happy Clients",
    colorClass: "text-[#a855f7]",
    bgClass: "bg-[#a855f7]/10",
    borderClass: "border-[#a855f7]/20",
    glowClass: "shadow-[0_0_20px_rgba(168,85,247,0.15)]",
  },
  {
    icon: LuSmartphone,
    value: "50M+",
    label: "Downloads",
    colorClass: "text-[#06b6d4]",
    bgClass: "bg-[#06b6d4]/10",
    borderClass: "border-[#06b6d4]/20",
    glowClass: "shadow-[0_0_20px_rgba(6,182,212,0.15)]",
  },
  {
    icon: LuShieldCheck,
    value: "99.9%",
    label: "Crash-Free Apps",
    colorClass: "text-[#3b82f6]",
    bgClass: "bg-[#3b82f6]/10",
    borderClass: "border-[#3b82f6]/20",
    glowClass: "shadow-[0_0_20px_rgba(59,130,246,0.15)]",
  },
  {
    icon: LuPercent,
    value: "40%",
    label: "Faster Development",
    colorClass: "text-[#d946ef]",
    bgClass: "bg-[#d946ef]/10",
    borderClass: "border-[#d946ef]/20",
    glowClass: "shadow-[0_0_20px_rgba(217,70,239,0.15)]",
  },
  {
    icon: LuShield,
    value: "100%",
    label: "Client Satisfaction",
    colorClass: "text-[#6366f1]",
    bgClass: "bg-[#6366f1]/10",
    borderClass: "border-[#6366f1]/20",
    glowClass: "shadow-[0_0_20px_rgba(99,102,241,0.15)]",
  },
];

// 3. Why Choose Us / Solutions Block
export const reactSolutionsAndProcessData = {
  buildSubtitle: "WHAT WE BUILD",
  buildTitle: "Modular React Solutions for Every Product Requirement",
  buildCards: [
    {
      title: "Custom React UI/UX",
      desc: "Build fast and interactive user interfaces optimized for performance and engagement.",
      icon: FaReact,
      colorClass: "text-[#61dafb]",
      bgClass: "bg-[#61dafb]/10",
      borderClass: "border-[#61dafb]/20 hover:border-[#61dafb]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(97,218,251,0.25)]",
    },
    {
      title: "React Component Architecture",
      desc: "Develop reusable and modular components for scalable frontend systems.",
      icon: LuLayers,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "SPA Development",
      desc: "Create dynamic web apps with smooth navigation and fast single-page routing.",
      icon: FaUniversalAccess,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "State Management Solutions",
      desc: "Implement Redux and Context API for predictable and stable application behavior.",
      icon: LuSettings,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "React Performance Optimization",
      desc: "Optimize rendering speed and improve overall frontend efficiency and responsiveness.",
      icon: FiZap,
      colorClass: "text-[#34d399]",
      bgClass: "bg-[#34d399]/10",
      borderClass: "border-[#34d399]/20 hover:border-[#34d399]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(52,211,153,0.25)]",
    },
    {
      title: "Enterprise React Solutions",
      desc: "Build scalable and secure React applications for complex, high-traffic business systems.",
      icon: LuBuilding2,
      colorClass: "text-[#f59e0b]",
      bgClass: "bg-[#f59e0b]/10",
      borderClass: "border-[#f59e0b]/20 hover:border-[#f59e0b]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(245,158,11,0.25)]",
    },
  ],
  processSubtitle: "OUR REACT ENGINEERING FRAMEWORK",
  processTitle: "How We Build Scalable Frontend Systems",
  processSteps: [
    { step: "01", title: "Architecture Planning", description: "Plan React component structure and app scalability roadmap.", icon: LuClipboardList },
    { step: "02", title: "Agile Development", description: "Build React features in iterative and fast delivery weekly cycles.", icon: LuCode },
    { step: "03", title: "Component Development", description: "Create reusable and optimized React UI components for the system.", icon: LuLayers },
    { step: "04", title: "State Management", description: "Manage app data flow using robust Redux or Context API setups.", icon: LuSettings },
    { step: "05", title: "Performance Optimization", description: "Improve React rendering speed and UI responsiveness profiles.", icon: LuCircleCheck },
    { step: "06", title: "Code Quality Assurance", description: "Ensure stable, bug-free and maintainable React applications.", icon: LuRocket },
  ],
  benefitsSubtitle: "WHY INVEST IN THE REACT ECOSYSTEM?",
  benefitsTitle: "Built for Fast and Fluid Digital Experiences",
  benefits: [
    "Fast virtual DOM for instantaneous UI updates",
    "Reusable component system to streamline maintenance",
    "Clean state sync via predictable data layers",
    "Massive open source package ecosystem",
    "Native mobile support via React Native",
    "SEO-friendly server-side rendering (SSR)",
    "Scalable frontend structure for enterprise growth",
  ],
  logoImage: "/images/serviceBanners/ReactBanner.webp",
  whiteLogoImage: "/images/serviceBanners/ReactW.webp",
};

// 4. Portfolio Data Block
export const reactPortfolioData = {
  subtitle: "OUR CASE STUDIES",
  title: "React Implementations Running at Massive Scale",
  buttonText: "View All Projects",
  buttonLink: "#all-projects",
  apps: [
    {
      title: "Nexus Core Dash",
      badge: "Custom UI/UX",
      badgeColor: "bg-[#61dafb]/10 text-[#61dafb] border-[#61dafb]/20",
      desc: "A highly dynamic administrative console featuring fluid rendering updates and nested routing structures.",
      downloads: "Fast Interactive",
      rating: "4.9",
      image: "/images/backend-dev.jpg",
    },
    {
      title: "OmniChannel Portal",
      badge: "Cross Platform Logic",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "Enterprise system architecture running shared operational business logic across web and React Native apps.",
      downloads: "Seamless Sync",
      rating: "4.8",
      image: "/images/fullstack-dev.jpg",
    },
  ],
};

// 5. Technologies & Ecosystem Partners Block
export const reactTechnologiesData = {
  techTitle: "OUR EXTENSIVE TOOL STACK",
  technologies: [
    { name: "ReactJS", icon: "ReactJS" },
    { name: "Redux", icon: "Redux" },
    { name: "React Router", icon: "Router" },
    { name: "Axios", icon: "Axios" },
    { name: "Material UI", icon: "MUI" },
    { name: "Styled Components", icon: "Styled" },
  ],
  trustTitle: "TRUSTED BY ENTERPRISES WORLDWIDE",
  trustClients: [
    { image: "/images/logo/google_logo.png", alt: "google_logo" },
    { image: "/images/logo/microsoft_logo.png", alt: "microsoft_logo" },
    { image: "/images/logo/amazon_logo.png", alt: "amazon_logo" },
    { image: "/images/logo/Adobe_Corporate_logo.png", alt: "adobe_logo" },
    { image: "/images/logo/IBM_logo.png", alt: "ibm_logo" },
    { image: "/images/logo/Oracle_logo.png", alt: "oracle_logo" },
  ],
};

// 6. About Overview Data Block
export const reactAboutData = [
  {
    title: "React JS Development Services for High-Performance Web Applications",
    content: (
      <>
        Modern digital products require interfaces that are fast, responsive, and easy to scale as businesses grow. Reliable{" "}
        <b className="text-text-primary font-semibold">react js development services</b> help organizations build dynamic web applications that improve user interaction and overall
        product performance. Many businesses face challenges with slow interfaces, inconsistent user experiences, and difficult-to-manage frontend systems. At{" "}
        <b className="text-text-primary font-semibold">Tycho Technologies</b>, React-based solutions are developed around scalability, usability, and business goals to help
        companies create high-performing digital products that support long-term growth.
      </>
    ),
  },
  {
    title: "React JS Development Company for Scalable User Experiences",
    content: (
      <>
        Creating a successful web application depends on delivering seamless interactions and consistent performance across devices. A trusted{" "}
        <b className="text-text-primary font-semibold">react js development company</b> helps businesses build flexible interfaces that improve navigation, responsiveness, and
        customer engagement. Companies investing in <b className="text-text-primary font-semibold">react js web development</b> often experience stronger usability because modern
        frontend systems adapt more effectively to changing user needs. Tycho Technologies focuses on practical React frameworks designed to improve performance while supporting
        business scalability and product flexibility.
      </>
    ),
  },
  {
    title: "React JS App Development Services for Better Product Performance",
    content: (
      <>
        A strong digital experience improves how users interact with products and complete important actions. Reliable{" "}
        <b className="text-text-primary font-semibold">react js app development services</b> help businesses create responsive applications that improve customer satisfaction and
        retention. Organizations looking to strengthen frontend architecture often combine modern development strategies with{" "}
        <a href="https://tychotechnologies.com/angular-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          angular development services
        </a>{" "}
        to support flexible ecosystems and improve compatibility across different business requirements.
      </>
    ),
  },
  {
    title: "Why Businesses Choose a React JS Development Company in India",
    content: (
      <>
        The demand for a trusted <b className="text-text-primary font-semibold">react js development company in india</b> continues to grow as businesses seek faster and more
        scalable frontend technologies. Companies looking to <b className="text-text-primary font-semibold">hire react js developers</b> often prioritize usability,
        maintainability, and performance-focused development for long-term digital growth. Businesses partnering with Tycho Technologies gain access to customized React frameworks
        built around measurable business objectives. Many organizations also strengthen product experiences through{" "}
        <a href="https://tychotechnologies.com/frontend-app-development-services-india" className="text-cyan-400 underline hover:text-cyan-300">
          frontend app development services
        </a>{" "}
        to create smoother and more engaging digital platforms.
      </>
    ),
  },
];
// 7. Core FAQs Preserved Intact
export const reactFaqs = [
  {
    q: "Why is React Js development in India a good choice for businesses?",
    a: "React Js development in India is a great option because it combines technical expertise with cost efficiency. Indian developers are experienced in building scalable, high-performance React applications and follow international development standards, making it ideal for startups and enterprises alike.",
  },
  {
    q: "What makes a React JS development company in Delhi/NCR stand out?",
    a: "A React JS development company in Delhi/NCR stands out by offering skilled developers, strong project management, and easy communication due to favorable time-zone overlap. The region is known for its robust IT ecosystem and ability to deliver reliable, modern React solutions.",
  },
  {
    q: "What services are included in React JS development services in India?",
    a: "React JS development services in India typically include custom web app development, UI/UX design, migration to React, API integration, performance optimization, and ongoing support to ensure smooth and scalable applications.",
  },
];

// 8. Backwards Compatibility Exports (Kept for Legacy System Dependencies)
export const reactBenefits = [
  {
    icon: <FiZap className="w-8 h-8" />,
    title: "Virtual DOM",
    desc: "React's virtual DOM ensures fast and efficient UI updates, minimizing performance bottlenecks.",
  },
  {
    icon: <FiCpu className="w-8 h-8" />,
    title: "Component Reusability",
    desc: "Build once, use everywhere. We create modular components that speed up development and maintenance.",
  },
  {
    icon: <FiShield className="w-8 h-8" />,
    title: "Predictable State",
    desc: "Using tools like Redux or Context API to ensure your application's state is manageable and scalable.",
  },
];

export const reactServices = [
  {
    icon: <FaReact size={36} />,
    title: "Custom React UI/UX",
    description: "Designing and developing interactive user interfaces that offer high user engagement.",
    image: "/images/backend-dev.jpg",
    link: "#",
  },
  {
    icon: <FaMobile size={36} />,
    title: "React Native Integration",
    description: "Sharing logic between web and mobile for a consistent cross-platform experience.",
    image: "/images/fullstack-dev.jpg",
    link: "#",
  },
  {
    icon: <FaUniversalAccess size={36} />,
    title: "SPA Development",
    description: "Creating seamless Single Page Applications with fast routing and state management.",
    image: "/images/cms-dev.jpg",
    link: "#",
  },
];

export const reactProcessSteps = [
  {
    step: "01",
    title: "Architecture Planning",
    description: "Defining the component structure and state management strategy for your React application.",
    points: ["Component mapping", "State strategy", "Library selection"],
  },
  {
    step: "02",
    title: "Agile Sprints",
    description: "Developing features in short cycles to ensure rapid feedback and iterative improvements.",
    points: ["Bi-weekly updates", "Continuous testing", "Feature validation"],
  },
  {
    step: "03",
    title: "Quality Assurance",
    description: "Rigorous testing of React components for performance, accessibility, and cross-browser compatibility.",
    points: ["Unit testing", "E2E testing", "Performance profiling"],
  },
];

export const reactTechStack = ["ReactJS", "Redux", "Hooks", "React Router", "Axios", "Material UI", "Styled Components"];

export const ReactTechIcons = {
  ReactJS: <FaReact />,
  Redux: <SiRedux />,
  Hooks: <FaPlug />,
  "React Router": <SiReactrouter />,
  Axios: <SiAxios />,
  "Material UI": <SiMaterialdesign />,
  "Styled Components": <SiStyledcomponents />,
};
